import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconAIMagicGradient(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M7.51818 8.01818C6.83939 8.69697 6.5 9.52424 6.5 10.5C6.5 9.52424 6.16061 8.69697 5.48182 8.01818C4.80303 7.33939 3.97576 7 3 7C3.97576 7 4.80303 6.66061 5.48182 5.98182C6.16061 5.30303 6.5 4.47576 6.5 3.5C6.5 4.47576 6.83939 5.30303 7.51818 5.98182C8.19697 6.66061 9.02424 7 10 7C9.02424 7 8.19697 7.33939 7.51818 8.01818Z"
        fill="url(#paint0_linear_402_5516)"
      />
      <path
        d="M15.3273 15.8273C13.7758 17.3788 13 19.2697 13 21.5C13 19.2697 12.2242 17.3788 10.6727 15.8273C9.12121 14.2758 7.2303 13.5 5 13.5C7.2303 13.5 9.12121 12.7242 10.6727 11.1727C12.2242 9.62121 13 7.7303 13 5.5C13 7.7303 13.7758 9.62121 15.3273 11.1727C16.8788 12.7242 18.7697 13.5 21 13.5C18.7697 13.5 16.8788 14.2758 15.3273 15.8273Z"
        fill="url(#paint1_linear_402_5516)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_402_5516"
          x1="3"
          y1="3.5"
          x2="24.3219"
          y2="15.6894"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#337FFF" />
          <stop offset="1" stopColor="#E039CE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_402_5516"
          x1="3"
          y1="3.5"
          x2="24.3219"
          y2="15.6894"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#337FFF" />
          <stop offset="1" stopColor="#E039CE" />
        </linearGradient>
      </defs>
    </BaseIcon>
  );
}
